import React, { useState, useEffect } from 'react';
import RecentPostList from '../Components/RecentPostList';
import CategoryWidget from '../Components/CategoryWidget';
import TagWidget from '../Components/TagWidget';
import SearchBox from '../Components/SearchBox';

const BlogSidebar = () => {

    return (
        <div class="blog-details-right-area blog-right-sidebar">
            {/* <SearchBox /> */}
            <div class="blog-widget recent-post-widget" data-aos="fade-up"
                data-aos-duration="1200">
                <RecentPostList />
            </div>

            <div class="blog-widget categories-widget" data-aos="fade-up"
                data-aos-duration="2400">
                <CategoryWidget />
            </div>

            <div class="blog-widget tags-widget" data-aos="fade-up"
                data-aos-duration="2800">
                <TagWidget />
            </div>
        </div>
    );
};

export default BlogSidebar;